import './Neem.css'
import neem from '../../assets/neem.png'

function NeemProfile() {
    return (
      <div id="neemWrapper">
      <div id="neemProfile">
        <div id="grayBackground">
          <div id="textContainer">
            <h1>Neem <span>Zaman</span></h1>
            <img src={neem} height={200} width={200} alt='pixel art of neem'/>
            <p>Hi! I'm Neem and I'm a third year Computer Science student at the University at Buffalo.
              I enjoy learning new skills and hobbies -- I play guitar and the keyboard, and I'm currently 
              learning how to draw pixel art. I drew this picture of myself recently!! I want to be able 
              to make simple animations out of them, so that I can use them as game assets for fun!
            </p>
          </div>
        </div>
      </div>
      </div>
    );
  }

  export default NeemProfile